function getSearchURLParams(url)
{
    if(typeof url !== "string") {
        return {};
    }
   var urlSplit = url.split("?");
   if(urlSplit.length < 2) {
       return {};
   }
   return _.object(_.map(urlSplit[1].split("&"), function(params) {
       return params.split("=");
   }));
}
var jQuery = require("jQuery");
function getSuitelet(script, deploy) {
   return {"customscript_ns_sc_sl_blog_entity_loader:customdeploy_ns_sc_sl_blog_entity_loader":"/app/site/hosting/scriptlet.nl?script=2442&deploy=1&compid=659947&ns-at=AAEJ7tMQ22cPORkAQHwE6dVI6kzx1MoIJdKHTa8-Djwk-MmOLf4","customscript_ns_sc_sl_blog_post_searcher:customdeploy_ns_sc_sl_blog_post_searcher":"/app/site/hosting/scriptlet.nl?script=2444&deploy=1&compid=659947&ns-at=AAEJ7tMQ7Geo02jeZL3geEpyio4wXO84ZKQhZUu2CqORHUZGvj0","customscript_ns_sc_sl_blog_url_prov:customdeploy_ns_sc_sl_blog_url_prov_dep":"/app/site/hosting/scriptlet.nl?script=2443&deploy=1&compid=659947&ns-at=AAEJ7tMQMK5kCTpAnT_Jwm6Vna7I1vmrtt2_D3j8a8GnkP_YaFw"}[script + ":" + deploy];
}
var xhrFactory = jQuery.ajaxSettings.xhr;
jQuery.ajaxSettings.xhr = function() {
   var xhr = xhrFactory.apply(this, arguments);
   var open = xhr.open;
   xhr.open = function () {
        var url = arguments[1];
        var assocParams = getSearchURLParams(url);
        if(assocParams.hasOwnProperty("script") && assocParams.hasOwnProperty("deploy")) {
            var hashed = getSuitelet(assocParams["script"], assocParams["deploy"]);
            if(hashed) {
                var hashedParams = getSearchURLParams(hashed);
                var keys = Object.keys(assocParams);
                for (var i=0; i<keys.length; i++) {
                    var key = keys[i];
                    var value = assocParams[key];
                    if(!hashedParams.hasOwnProperty(key))
                    {
                        hashed += "&" + key + "=" + value;
                    }
                }
                arguments[1] = hashed;
            }
        }
        return open.apply(this, arguments);
    }
    return xhr;
}